<template>
  <div id="services" class="networkshops-services">
    <h2 class="vz-text-align-left">{{ data.title }}</h2>
    <div class="networkshops-services-items">
      <div v-for="{icon, text} of items">
        <vz-icon
          :url="icon"
          no-masked-icon
          variant="primary"
          size="50"
        />
        <span>{{ text }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VzIcon from '~/components/ui-kit/vz-icon.vue';

const props = defineProps({
  isMarketplaces: {
    type: Boolean,
    default: false
  }
})

const data = {
  title: 'Перечень услуг',
  order: 'Оформление заявок для физических лиц, юридических лиц и ИП',
  storage: 'Хранение груза до отгрузки',
  delivery: 'Доставка в указанную дату и время авизации',
  cargo: 'Проверка груза при отправке на соответствие требованиям сети',
}

const items = computed(() => [
  {
    icon: '/svg/vz-signature.svg',
    text: data.order
  },
  {
    icon: '/svg/lock.svg',
    text: `${data.storage} ${props.isMarketplaces ? ' на склад маркетплейса' : ' в торговую сеть'}`
  },
  {
    icon: '/svg/vz-time-success.svg',
    text: data.delivery
  },
  {
    icon: '/svg/vz-box-success.svg',
    text: data.cargo
  },
])
</script>

<style scoped lang="scss">
.networkshops-services {
  margin-bottom: 60px;

  &-items {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;

    > div {
      background-color: $box-gray;
      border-radius: 4px;
      padding: 40px 30px 30px 33px;
      display: flex;
      align-items: flex-start;
      gap: 20px;
    }
  }

  @media screen and (max-width: $pub-md) {
    margin-bottom: 40px;
    &-items {
      grid-template-columns: repeat(2, 1fr);
      gap: 10px;
    }
  }

  @media screen and (max-width: $pub-xs) {
    &-items {
      grid-template-columns: repeat(1, 1fr);
    }
  }
}
</style>
